import './aliyun_captcha.scss'
import {
  apiTradeGeneralTradeQueryVerifyCommodity,
  ApiTradeGeneralTradeQueryVerifyCommodityResponse,
  apiTradeGeneralTradeVerifyCaptcha,
} from '@/api'
import { EventBus, loadResource, LoadResourceUrlType, memoize } from 'vtils'
import { Toast } from 'vant'

// 阿里云验证码
// https://help.aliyun.com/zh/captcha/captcha2-0/user-guide/add-a-web-or-html5-client-to-alibaba-cloud-captcha-2?spm=a2c4g.11186623.help-menu-28308.d_1_2_0.7dad7b7fewubu4&scm=20140722.H_2360563._.OR_help-T_cn#DAS#zh-V_1
export class AliyunCaptcha {
  private static bus = new EventBus<{
    onVerify: (params: string) => any
    onVerifyResult: (params: {
      captchaResult: boolean
      bizResult: boolean
    }) => any
  }>()

  private static token = ''

  // 初始化
  private static init = memoize(
    async (options: { prefix: string; sceneId: string }): Promise<void> => {
      await loadResource({
        type: LoadResourceUrlType.js,
        path: 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js',
      })
      const captchaEl = document.createElement('div')
      captchaEl.id = 'aliyun-captcha-element'
      document.body.appendChild(captchaEl)
      const buttonEl = document.createElement('div')
      buttonEl.id = 'aliyun-captcha-button'
      document.body.appendChild(buttonEl)
      return new Promise<void>(resolve => {
        ;(window as any).initAliyunCaptcha({
          SceneId: options.sceneId, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
          prefix: options.prefix, // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
          mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
          element: '#aliyun-captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
          button: '#aliyun-captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
          captchaVerifyCallback: (params: string) =>
            new Promise(resolve => {
              AliyunCaptcha.bus.once('onVerifyResult', resolve)
              AliyunCaptcha.bus.emit('onVerify', params)
            }), // 业务请求(带验证码校验)回调函数，无需修改
          onBizResultCallback: (_result: boolean) => {
            // ...
          }, // 业务请求结果回调函数，无需修改
          getInstance: (_instance: any) => {
            resolve()
          }, // 绑定验证码实例函数，无需修改
          slideStyle: {
            width: 360,
            height: 40,
          }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
          language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        })
      })
    },
    options => `${options.prefix}_${options.sceneId}`,
  )

  // 显示
  private static async showCaptcha(options: {
    onVerify: (params: string) => Promise<boolean>
  }) {
    AliyunCaptcha.bus.clear()
    AliyunCaptcha.bus.on('onVerify', async params => {
      try {
        const isSuccess = await options.onVerify(params)
        AliyunCaptcha.bus.emit('onVerifyResult', {
          captchaResult: isSuccess,
          bizResult: isSuccess,
        })
      } catch {
        AliyunCaptcha.bus.emit('onVerifyResult', {
          captchaResult: false,
          bizResult: false,
        })
      }
    })
    document.querySelector<HTMLButtonElement>('#aliyun-captcha-button')?.click()
  }

  static async showIfNeeded(options: { goodsId: string }): Promise<void> {
    const loading = Toast.loading({
      duration: 0,
    })
    const res = await apiTradeGeneralTradeQueryVerifyCommodity(
      {
        commodityId: options.goodsId,
      },
      {
        noErrorToast: true,
      },
    ).catch(() => ({} as ApiTradeGeneralTradeQueryVerifyCommodityResponse))
    if (!res.enableVerifyCaptcha) {
      AliyunCaptcha.token = ''
      loading.close()
      return
    }
    await AliyunCaptcha.init({
      prefix: res.verifyIdentity!,
      sceneId: res.verifySceneId!,
    })
    loading.close()
    return new Promise(resolve => {
      AliyunCaptcha.showCaptcha({
        onVerify: async params => {
          const res = await apiTradeGeneralTradeVerifyCaptcha(
            {
              captchaVerifyParam: params,
            },
            {
              noErrorToast: true,
            },
          )
          AliyunCaptcha.token = res.captchaToken || ''
          if (AliyunCaptcha.token) {
            resolve()
          }
          return !!AliyunCaptcha.token
        },
      })
    })
  }

  static getToken(): string {
    return AliyunCaptcha.token
  }
}
